import { render, staticRenderFns } from "./BaseInput.vue?vue&type=template&id=3370534a&"
import script from "./BaseInput.vue?vue&type=script&lang=js&"
export * from "./BaseInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports